import { post } from "../axios";
import ApiResponse from "sr/models/ApiResponse";
import { HandleApiError } from "sr/helpers/functions/HandleApiError";
import { SuccessMessage } from "sr/helpers/functions/SuccessMessage";

export const changePassword = async (postData:any) => {
    try {
    return await post<ApiResponse<[]>>('/auth/resetoldpassword', postData).then((res)=> {
        if(res?.success===true) {
            SuccessMessage('API.SUCCESS.PASSWORD.CHANGE')
                return res
        }
        else {
            HandleApiError(res.error.msg)
            return null
        }
  });
}catch(e) {
    HandleApiError(e)
}
};
